import { format } from 'date-fns';
import { getDateFromApiDate } from '../dates';

// 'YYYY-MM-DD'
const displayDate = articleDate => {
    if (!articleDate) return null;
    const date = getDateFromApiDate(articleDate);
    return format(date, 'MMMM d, y');
};

export const mapSearchSessionToProps = ({ hit, isFavorite, onClick }) => {
    const id = parseInt(hit.objectID.split('-')[1], 10);

    return {
        id,
        title: hit.title,
        url: `${window.location.protocol}//${window.location.hostname}${hit.url}`,
        sessionType: Array.isArray(hit.session_type) ? hit.session_type[0] : hit.session_type,
        sessionStatus: hit.session_status,
        sessionStartUnix: hit.session_start_time,
        sessionEndUnix: hit.session_end_time,
        sessionRoom: hit.session_room,
        photoURL: hit.photo_url,
        description: hit.description,
        event: hit.event,
        isFavorite,
        onClick,
    };
};
